// import el from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包

const m = {
	// message: {
		tips: '提示',
		cancel: '取 消',
		sure: '确 定',
		search: '查 询',
		add: '新增',
		delete: '删除',
		modify: '修改',
		back: ' 返回 ',
		addSuccess: '新增成功',
		modifySuccess: '修改成功',
		deleteSuccess: '删除成功',
		uploadSuccess: '上传成功',
		sureDelete: '是否确认删除？',
		chooseDelete: '请勾选删除内容',
		enableFlag: '状态',
		status: '状态', 
		enable: '启用',
		disable: '禁用',
		operation: '操作',
		chooseDate: '选择日期',
		keyName: '关键字',
		addLine: '新增行',
		deleteLine: '删除行',
		addColumn: '新增列',
		deleteColumn: '删除列',
		pleaseChoose: '请选择',
		exportResults: '导出查询结果',
		chooseExpNum: '选择导出段',
		//template
		exchangeTemplate: '下载外币汇率配置模板',
		discountTemplate: '下载借款利率配置模板',
		taxRateTemplate: '下载税率配置模板',
		orgTemplate: '下载租赁组织主数据配置模板',
		onlyTemplate: '只能上传模板文件',
		dataTemplate: '下载数据权限模板',
		EPOTemplate: '下载采购订单租赁要素补充模板',
		leaseTemplate: '下载租赁物件手工维护模板',
		POTemplate: '下载PO接收重分类模板',
		userTemplate: '下载用户配置模板',
		leaseAnnotationTemplate: '下载租赁附注模板',
		chooseFile: '浏览',
		uploadFile: '上传文件',
		uploadErr: '上传错误信息',
		exportErr: '导出错误信息',
		errOrder: '序号',
		errDescription: '描述',
        oldBeginningBalance: '使用原折现率计算的现值（租赁期缩短专用）',

		//字段
		primaryLedger: '主账套',
        primaryLedgerId: '主账套ID',
		ouName: '公司主体',
		costCenter: '成本中心',
		currency: '本位币',
		leaseType: '租赁类型',
		dataSource: '数据来源',
		region: '国家或地区',
		leaseItemCategory: '采购内容或物料说明',
		leaseTerm: '租赁周期(月数)',
		leaseItemType: '租赁物件类型',
		usefulLife: '折旧年限',
		assetBook: '资产账簿',
		assetCategory: '资产类别',
		depreciationExpenseAccount: '折旧费用COA',
		contractCurrency: '合同币种',
		legalEntity: '法人实体',
		leaseItemNumber: '租赁物件编号',
		transactionType: '事务处理类型',
		poNumber: '订单号',
		contractNumber: '合同编号',
		referenceContractNumber: '参考合同编号',
		contractDate: '合同日期',
		leaseDate: '租赁日期',
		originalLeaseItemNumber: '原租赁物件编号',
		revaluationDate: '补充协议生效日期',
		uploader: '上传人员',
		earlyTerminateFlag: '提前终止标识',
		earlyTerminateStatus: '提前终止审批状态',
		leaseItemStatus: '状态',
		vendorName: '供应商名称',
		contractStartDate: '合同开始日期',
		contractEndDate: '合同结束日期',
		extensionFlag: '是否行使续约权',
		leaseItemDescription: '采购说明或验收单位',
		leaseStartDate: '租赁开始日',
		leaseEndDate: '租赁结束日',
		purchaseRightFlag: '是否会行使购买权',
		shortTermExemptionFlag: '短期豁免',
		lowValueExemptionFlag: '低价值豁免',
		variableExemptionFlag: '可变付款豁免',
		earlyTerminateOa: '提前终止人员OA账号',
		earlyTerminateChecker: '提前终止检查人员OA账号',
		earlyTerminateReviewer: '提前终止复核人员OA账号',
		earlyTerminateMes: '提前终止信息',
		transitionOption: '转换方法',
		rejectComment: '驳回原因',
		poVarchargeAccount: 'PO验收行COA',
		extensionTerm: '续约选择权的续约年限（月数）',
		terminateFrom: '行使续约权的时期从',
		controlDateTo: '出租方控制的可选择租赁期至',
		startRate: '租赁开始日汇率',
		purchaseRightFlag: '是否有购买权',
		purchaseValue: '采购价值是否大于5000美金',
		leaseItemComment: '采购备注',
		poLineNumber: '订单行序号',
		deliveryBatchNumber: '交付批次',
		referenceValue: '赠送资源的参考价值',
		annualDiscountRate: '年折现率',
		financeLeaseFlag: '是否为融资租赁',
		subleaseFlag: '是否为转租赁标的',
		serialNumber: '租赁物件序列号',
		originalPoNumber: '原订单号',
		originalPoLineNumber: '原订单行序号',
		originalDeliveryBatchNumber: '原交付批次',
		partialCancelPercentage: '部分取消百分比',
		assetAdjAmount: '资产变动额',
		pandlAdj: '损益调整额',
		liabilityAdjUstment: '负债调整额',
		comment: '备注',
		modificationReason: '变更具体原因',
		paymentDateFrom: '结算期开始月',
		paymentDateTo: '结算期终止月',
		leasePaymentType: '支付类型',
		frequentFlag: '固定频率(F)/非固定频率(V)/免收费 (RF)',
		paymentFrequency: '付款周期',
		usedCount: '按照付款周期的使用数量',
		unitType: '单位',
		unitPrice: '单价',
		periodFlag: '期初/期末支付',
		beginBalances: '租赁负债期初金额',
		paymentAmount: '支付金额',
		interest: '利息费用',
		principal: '本金付款',
		endBalances: '租赁负债期末金额',
		faAccountedFlag: '是否已经过账',
		cfAccountedFlag: '是否已对固定租金做重分类',
		useright: '使用权资产期初余额',
		starttime: '资产开始使用时间',
		depreciation: '折旧月数',
		usefulMethod: '折旧方法',
		assetNumber: '资产编号',
		accountingPeriod: '折旧期',
		usefulAmount: '每期折旧金额',
		usefulTotalAmount: '累计折旧',
		assetOriginalAmount: '资产原值',
		assetNetAmount: '资产净值',
		extensionRightFlag: '是否有续约权',
		closeFlag: '是否作废',
		orderCurrency: '订单币种',
		//login
		chinese: '中文',
		english: '英语',
		Lap: '腾讯租赁会计平台',
		LapStyle: 'psc-font-1',
		forgetPwd: '忘记密码',
    passExpire1: '密码还有',
    passExpire2: '天到期，请尽快修改密码',
    passExpire3: '密码已到期，请修改密码',
        forgetPwdHelp: '如果忘记密码，请联系系统管理员',
		systemLang: '系统语言',
		inputAccount: '请输入用户名/手机/邮箱',
		inputPwd: '请输入密码',
		login: '登 录',
		mobile: '手机',
		newPwd: '新密码',
		confirmPwd: '确认密码',
		code: '验证码',
		sendCode: '发送验证码',
		changePwd: '修改密码',
		oldPwd: '旧密码',
		inputAccountAndPwd: '请输入用户名和密码',
		inputAccountOrPwd: '请输入用户名或密码',
		inputMobie: '请输入手机号',
		inputNewPwd: '请输入新密码',
		inputOldPwd: '请输入旧密码',
		inputConfirmPwd: '请输入确认密码',
		inputCode: '请输入验证码',
		inputPwdRule: '请输入8-15位数字大小写字母组合密码',
		input: '请输入',
		resetPwdSuc: '重置密码成功',
		changePwdSuc: '修改密码成功',
		pwdMessage1: '新密码和旧密码一致!',
		pwdMessage2: '新密码和确认密码不一致!',
		//PageIndex
		LapModule: '租赁核算模块',
		LapModuleStyle: 'psc-font-2',
		exit: '退出',
		sureExit: '是否确认退出？',

		CONFIG_MANAGE: '配置界面',
		PERIOD_MANAGE: '期间管理',
		EXCHANGE_RATE: '外币汇率配置',
		VALUE_SET: '值集维护',
		SYSTEM_MAPPING: '外围系统映射配置',
		LOAN_INTEREST_RATE: '借款利率配置',
		TAX_RATE: '税率配置',
		RENTAL_ORGANIZATION: '租赁组织主数据配置',
		DATA_PERMISSION: '数据权限',
		ACCOUNT_RULE: '科目规则维护配置',

		OPERATE_MANAGE: '操作界面',
		EPO_ORDER_LEASING: '采购订单租赁要素补充',
		UPLOAD_OPERATE: '上传界面',
		SEARCH_PAGE: '查询界面',
		FINANCE_INSPECT: '财务检查',
		FINANCE_REVIEW: '财务复核',
		UPLOAD_PO_RECEIVE: '实际付款上传界面',
		ACCOUNTING_ENTRIES: '会计分录查询',
		REPORT_QUERY: '报表查询',
		EXEMPT_OPERATION: '豁免操作',
		LEASE_ANNOTATION: '租赁附注',

		ACCOUT_MANAGE: '我的账户',
		USER_INFO: '用户信息',
		CHANGE_PASSWORD: '修改密码',

		SYSTEM_MANAGE: '系统管理',
		USER_MANAGE: '用户管理',
		ROLE_MANAGE: '角色管理',
		MENU_MANAGE: '菜单管理',
		BUTTON_MANAGE: '按钮管理',
		ENUM_MANAGE: '数据字典',
		LOG_MANAGE: '日志管理',

		uploadPage: '上传界面',
		operateDetail: '租赁物件详细信息',
		//config
        assetCostCoa: '资产原值COA',
        depreciationCoa: '累计折旧COA',
		//period
		fiscalYear: '财年',
		startDate: '开始日期',
		endDate: '结束日期',
		periodNum: '期间',
		periodStatus: '期间状态',
		periodStatus1: '打开',
		periodStatus2: '关闭',
		periodStatus3: '未来区间',
		periodStatusEdit: '期间状态编辑',
		startMonth: '起始月',
		chooseLedger: '请先选择主账套',
		ledgerNoData: '该主账套暂无数据',
		//Exchange Rates
		operatingUnit: '业务实体',
        ouCode: '业务实体代码',
        investErpFlag: '投资域ERP公司标识',
		currencyFrom: '币种从',
		currencyTo: '币种至', 
		validityPeriodFrom: '有效期从(含)',
		validityPeriodTo: '有效期至(含)',
		exchangeRate: '汇率',
		//value set
		valueSetSearch: '值集名称/编码',
		valuesetName: '值集名称',
		valuesetCode: '值集编码',
		createTime: '创建时间',
		fixedFlag: '是否可修改',
		valuesetLineContent: '值集行名称',
		valuesetLineCode: '值集行编码',
		valuesetLineProperty: '值集行属性',
		//maping
		outsideMapName: '映射名称',
		outsideMapCode: '映射编码',
		inputValue: '输入值',
		mapValue: '映射值',
		inputColumn: '输入值列',
		mapColumn: '映射值列',
		addInputColumn: '新增输入值列',
		addMapColumn: '新增映射值列',
		deleteInputColumn: '删除输入值列',
		deleteMapColumn: '删除映射值列',
		noData: '当前数据为空',
		//discount
		discountRateEffectiveFrom: '利率生效日期(含)',
		discountRateEffectiveTo: '利率终止日期(含)',
		discountRateType: '利率类型',
		leaseTermFrom: '租赁周期起(月数)(不含)',
		leaseTermTo: '租赁周期止(月数)(含)',
		discountRateSource: '折现利率来源',
		discountRate: '年折现率',
		borrowingRate: '借款利率',
		lendingRate: '贷款利率',
		//tax
		taxName: '税码',
		taxType: '税种',
		deductible: '可否抵扣',
		taxLogic: '计税逻辑',
		taxRate: '税率',
		//dataPermission
		OAAccount: 'OA账号',
		//accountRule
		documentType: '凭证场景类型',
		contentName: '分录行场景',
		sceneType: '场景类型',
		dcDirection: '方向',
		directionBorrow: '借',
		directionLoan: '贷',
		titleStage: '科目段',
		customColumn: '自定义列',
		columnName: '列名称',
		customColumnMax: '自定义列最多输入9列,请确认',
		//operatePage
		searchOptions: '查询条件:',
		tableOptions: '列表选项:',
		showSearch: '显示查询条件',
		hiddenSearch: '隐藏查询条件',
		enterUpload: '进入上传界面',
		enterYuanUpload: '元数据上传界面',
		sureAdvanceEnd: '确认提前终止',
		submit: '提交',
		closeBacklog: '关闭待办',
		advanceEnd: '提前终止',
		checkPass: '检查通过',
		reject: '驳回',
		reviewPass: '复核通过',
		postingErp: '生成会计分录',
		closeWaiver: '关闭豁免',
		surePass: '是否确认通过?',
		operateSuccess: '操作成功',
		sureCloseBacklog: '是否确认关闭待办?',
		sureReject: '是否确认驳回?',
		sureCloseExemption: '是否确认关闭豁免',
		sureSubmit: '是否确认提交?',
		rejectReason: '驳回原因',
		singleReviewPass: '请单个复核通过',
		chooseChecked: '请选择已检查的租赁物件',
		chooseReviewOrPosting: '请选择已复核或已过账的租赁物件',
		choosePosting: '请选择已过账的租赁物件',
		chooseSameOU: '请选择相同公司主体的租赁物件',
		chooseAdvanceEnd: '请选择事务处理类型为提前终止的租赁物件',
		chooseSubmitOrPosting: '请选择待提交或已驳回的租赁物件',
		chooseSubmit: '请选择待提交的租赁物件',
		chooseSingle: '请单个勾选',
		allPost: '没有打开的会计期',
		onlyRejectChecked: '只能驳回已检查的租赁物件',
		chooseExemption: '请选择已豁免的租赁物件',
		lengthMax40: '长度最多40',
		advanceEndDate: '提前终止日期',
		periodName: '会计期',
    choose: '选择',
        periodNameStart: '会计期开始',
        periodNameEnd: '会计期结束',
		//PO receive
		paymentPeriod: '付款计划期间',
		generalLedgerPeriod: '总帐期间',
		submitted: '已提交',
		notSubmitted: '未提交',
		poChargeAccount: '银行中转科目',
		receiptAmount: '实际付款金额',
		//account
		postPeriodName: '过账会计期',
		journalHeaderDesc: '分录头摘要',
		entryAbstract: '分录行摘要',
		journalName: '日记账名称',
		titleGroup: '科目组合',
        contract_currency: '合同币',
		DrContractCurrency: '借方金额（合同币种）',
		CrContractCurrency: '贷方金额（合同币种）',
		DrCurrency: '借方金额（本位币）',
		CrCurrency: '贷方金额（本位币）',
		//report
		reportName: '报表名称',
		startPeriodName: '开始期间',
		endPeriodName: '结束期间',
		//lease
		relatedParties: '是否包含关联方数据',
		convertCurrency: '折算币种',
		cashFlowReport: '现金流量表',
		interestPayment: '融资活动产生的现金流-支付利息',
		financingActivity: '融资活动产生的现金流-支付本金',
		operatingCashFlow: '经营活动产生的现金流',
		totalLeaseCashFlow: '租赁总现金流流出',
		cashFlowThisYear: '本年度现金流量披露报告',
		cashFlowLastYear: '上年度现金流量披露报告',
		exportLeasePayment: '实际付款信息导出',
		groupAssetUseful: '本集团资产年限范围',
		assetUsefulLifeFrom: '现在时点有效资产的使用年限从',
		assetUsefulLifeTo: '现在时点有效资产的使用年限至',
		relatedWorkingPaper: '工作底稿关联',
		assetUsefulLifeRange: '资产年限范围',
		leaseAssetLedgerReport: '租赁资产明细表',
		groupLeaseLiability: '本集团租赁负债',
    leaseLiability: '租赁负债中转余额',
		withinOneYear: '不超过一年',
		oneToTwo: '一年以上但两年以内',
		twoToFive: '两年以上但五年以内',
		thanFive: '五年以上',
		leaseLiabilityBalance: '租赁负债余额',
		thisYearPaymentSchedule: '本年还款付息计划表',
		lastYearPaymentSchedule: '上年还款付息计划表',
		leaseLiabilityOne: '一年内到期的租赁负债',
		leaseLiabilityOneOver: '一年后到期的租赁负债',
		assetDisclosure: '分部报告资产信息披露',
		domestic: '国内(货币精度)',
		domesticMillions: '国内(百万元)',
		overseas: '国外(货币精度)',
		overseasMillions: '国外(百万元)',
		assetInitialValue: '资产原值',
		assetsDepreciation: '资产累计折旧',
		assetNetValue: '资产净值',
		variablePayment: '可变付款额的披露',
		YTDThisYear: '本年数(货币精度)',
		YTDThisYearMillions: '本年数(百万元)',
		YTDLastYear: '上年数（货币精度）',
		YTDLastYearMillions: '上年数（百万元）',
		fixedPayment: '资本化物件的实际付款额',
    variablePayment3: '可变付款额的披露',
		variablePayment: '短期豁免物件的实际付款额',
    variablePayment1: '低价值豁免物件的实际付款额',
    variablePayment2: '可变豁免物件的实际付款额',
		leasePayment: '租赁付款额',
		percentage: '百分比（可变/租赁总付款额）',
		cashFlowDisclosureReport: '现金流量披露报告',
		nameWidth: '230',
		noDataSearchFirst: '暂无数据,请先查询',
		requirePeriodName: '会计期必填',
		requireSupplier: '是否包含关联方数据必填',
		inputRequire: '请输入必填项',
		
		//system
		userName: '用户名',
		roleName: '角色名称',
		email: '邮箱',
		userAccount: '账户名',
		mobileNumber: '手机号码',
		password: '密码',
		createBy: '创建人',
		updateBy: '更新人',
		updateTime: '更新时间',
		roleCode: '角色编码',
		save: '保存',
		roleInfo: '角色信息',
		relatedUsers: '关联用户',
		choose: '选择',
		relatedResources: '关联资源',
		chooseBtn: '选择按钮',
		chooseAll: '全选',
		chooseMenu: '请先选择菜单',
		menuNoBtn: '该菜单没有按钮',
		roleNameExist: '该角色名称已存在',
		saveSuccess: '保存成功',
		menuNameOrCode: '菜单名称/菜单编码',
		menuName: '菜单名称',
		menuCode: '菜单编码',
		menuLink: '菜单链接',
		menuType: '菜单类型',
		menuParentCode: '父节点编码',
		menuParentName: '父节点名称',
		menuSortNum: '排序号',
		menuIcon: '图标',
		firstMenu: '一级菜单',
		secondMenu: '二级菜单',
		buttonName: '按钮名称',
		buttonCode: '按钮编码',
		buttonType: '按钮类型',
		addItem: '新增子项',
		dictionaryName: '字典名称',
		chooseDic: '请先选择数据字典',
		logType: '日志类型',
		time: '时间',
		logResultMessage: '操作结果',
		clientIp: 'IP地址',

		navDicData: 'RENTAL_ITEM_DETAIL_NAV',
		documentTypeValueset: 'DOCUMENT_TYPE',
		titileTypeValueset: 'SUBJECT_TYPE',
		subentryLineValueset: 'SUBENTRY_LINE_TYPE',
    94:'待办',
    95:'已提交',
    96:'已检查',
    97:'已复核',
    98:'已过账',
    99:'已正常终止',
    100:'已撤回',
    101:'已调整',
    102:'已重估',
    103:'已提前终止',
    104:'已部分终止',
    105:'已驳回',
    112:'已关闭',
    118:'已租赁期缩短',
    119:'待提交',
    129:'已豁免',
    130:'豁免已关闭',

	// },
}

const el = {
	colorpicker: {
		confirm: '确定',
		clear: '清空'
	},
	datepicker: {
		now: '此刻',
		today: '今天',
		cancel: '取消',
		clear: '清空',
		confirm: '确定',
		selectDate: '选择日期',
		selectTime: '选择时间',
		startDate: '开始日期',
		startTime: '开始时间',
		endDate: '结束日期',
		endTime: '结束时间',
		prevYear: '前一年',
		nextYear: '后一年',
		prevMonth: '上个月',
		nextMonth: '下个月',
		year: '年',
		month1: '1 月',
		month2: '2 月',
		month3: '3 月',
		month4: '4 月',
		month5: '5 月',
		month6: '6 月',
		month7: '7 月',
		month8: '8 月',
		month9: '9 月',
		month10: '10 月',
		month11: '11 月',
		month12: '12 月',
	  	// week: '周次',
	  	weeks: {
	  		sun: '日',
	  		mon: '一',
	  		tue: '二',
	  		wed: '三',
	  		thu: '四',
	  		fri: '五',
	  		sat: '六'
	  	},
	  	months: {
	  		jan: '一月',
	  		feb: '二月',
	  		mar: '三月',
	  		apr: '四月',
	  		may: '五月',
	  		jun: '六月',
	  		jul: '七月',
	  		aug: '八月',
	  		sep: '九月',
	  		oct: '十月',
	  		nov: '十一月',
	  		dec: '十二月'
	  	}
	},
	select: {
		loading: '加载中',
		noMatch: '无匹配数据',
		noData: '无数据',
		placeholder: '请选择'
	},
	cascader: {
		noMatch: '无匹配数据',
		loading: '加载中',
		placeholder: '请选择'
	},
	pagination: {
		goto: '前往',
		pagesize: '条/页',
		total: '共 {total} 条',
		pageClassifier: '页'
	},
	messagebox: {
		title: '提示',
		confirm: '确定',
		cancel: '取消',
		error: '输入的数据不合法!'
	},
	upload: {
		deleteTip: '按 delete 键可删除',
		delete: '删除',
		preview: '查看图片',
		continue: '继续上传'
	},
	table: {
		emptyText: '暂无数据',
		confirmFilter: '筛选',
		resetFilter: '重置',
		clearFilter: '全部',
		sumText: '合计'
	},
	tree: {
		emptyText: '暂无数据'
	},
	transfer: {
		noMatch: '无匹配数据',
		noData: '无数据',
		titles: ['列表 1', '列表 2'],
		filterPlaceholder: '请输入搜索内容',
		noCheckedFormat: '共 {total} 项',
		hasCheckedFormat: '已选 {checked}/{total} 项'
	}
}

export {m, el}



// WEBPACK FOOTER //
// ./src/assets/lang/zh_CN.js